export enum AlertStatus {
	ACTIVE = 'ACTIVE',
	TRIGGERED = 'TRIGGERED',
	INACTIVE = 'INACTIVE',
}
